<template>
	<div class="">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px] h-[78vh]  mr-[10px] flex flex-col ">
					<div
						class="relative flex-1 overflow-y-auto shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[22px] box-border">
						<div class="mb-[42px] relative" style="z-index: 99;" v-if="current_question_type=='case'">

							<div
								class="answerSheetTitle bB-01  p-[16px] box-border relative text-[16px] text-[#1B2128] font-bold">
								【{{langInfo['Case description']}}】
							</div>
							<div class="pt-[16px] px-[13px] mb-[20px] box-border relative" style="line-height: 1.6;">
								<label v-html="caseTopicInfo.content"></label>
							</div>
							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo.cancel_collect:langInfo.click_collect"
									placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>

								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<!-- question_type=题目类型:1=单选,3=判断,5=简答 -->
							<div class="pl-[68px] box-border text-[#101010]" v-if="currentTopicInfo.question_type==1">
								<div v-for="(item,index) in caseOption"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer==item.key?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{item.key}}.</label>
									<label class="cursor-pointer" v-html="item.value"></label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==3">
								<!-- 判断题传 1对0错 -->
								<div class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer=='1'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['right']}}</label>
								</div>
								<div class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer=='0'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['wrong']}}</label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==5">
								<textarea maxlength="200" disabled class="w-[100%] h-[160px]"
									v-model="currentUserRecord.user_answer"></textarea>
							</div>
						</div>
						<div class="mb-[42px] relative" style="z-index: 99;" v-if="current_question_type=='single'">

							<div class="mb-[42px] relative z-10">
								<div class="flex  mb-[20px]">
									<el-tooltip class="item" effect="dark"
										:content="currentTopicInfo.is_user_collection==1?langInfo.cancel_collect:langInfo.click_collect"
										placement="bottom">
										<img @click="collectClick()"
											:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
											class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
									</el-tooltip>
									<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
										{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
											class="whitespace-pre-wrap"></span>
									</div>
								</div>
								<div class="pl-[68px] box-border text-[#101010]">
									<div v-for="(item,index) in optionsList" class="flex items-center mb-[10px] ">
										<img :src="item.isSelect?selectedImg:selectImg"
											class="w-[14px] h-[14px] mr-[10px]" />
										<label class="mr-[14px]">{{item.key}}.</label><label class="cursor-pointer"
											v-html="item.value"></label>
									</div>
								</div>
							</div>
						</div>


						<div class="bg-[#F5F5F5] p-[22px] box-border mb-[18px]">

							<!-- question_type=题目类型:1=单选,3=判断,5=简答 -->
							<div v-if="current_question_type=='case'">
								<div class="" v-if="currentTopicInfo.question_type==1">
									<div class="flex items-center mb-[10px]">
										<img v-if="currentUserRecord.user_answer==caseTopicInfo.answer"
											src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]"
											alt="" />
										<img v-else src="@/static/image/icon41.png" class="w-[24px] h-[24px] mr-[10px]"
											alt="" />
										<label v-if="currentUserRecord.user_answer==caseTopicInfo.answer"
											class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>
										<label v-else
											class="text-[20px] font-bold text-[#FF0100]">{{langInfo.study_paper_answer_wrong}}</label>
									</div>
									<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
										<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
										<label
											:class="currentUserRecord.user_answer==currentTopicInfo.answer?'text-[#68C340]':'text-[#FF0100]'">{{currentUserRecord.user_answer ||langInfo['no_answer']}}</label>
									</div>
									<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
										<label class=" min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
										<label>{{currentTopicInfo.answer}}</label>
									</div>
								</div>
								<div class="" v-else-if="currentTopicInfo.question_type==3">
									<div class="flex items-center mb-[10px]">
										<img v-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='1') &&currentUserRecord.user_answer!=''"
											src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]"
											alt="" />
										<img v-else-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='0') &&currentUserRecord.user_answer!=''"
											src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]"
											alt="" />
										<img v-else="(currentTopicInfo.answer==currentUserRecord.user_answer=='0') &&currentUserRecord.user_answer!=''"
											src="@/static/image/icon41.png" class="w-[24px] h-[24px] mr-[10px]"
											alt="" />
										<label
											v-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='1') &&currentUserRecord.user_answer!=''"
											class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>

										<label
											v-else-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='0') &&currentUserRecord.user_answer!=''"
											class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>


										<label v-else
											class="text-[20px] font-bold text-[#FF0100]">{{langInfo.study_paper_answer_wrong}}</label>
									</div>
									<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
										<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
										<label
											v-if="currentUserRecord.user_answer=='1'&&currentUserRecord.user_answer!=''"
											class="text-[#68C340]">{{langInfo['right']}}</label>
										<label
											v-else-if="currentUserRecord.user_answer=='0'&&currentUserRecord.user_answer!=''"
											class="text-[#68C340]">{{langInfo['wrong']}}</label>
										<label v-else>{{langInfo['no_answer']}}</label>
									</div>
									<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
										<label class=" min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
										<label>{{currentTopicInfo.answer=='1'?langInfo['right']:langInfo['wrong']}}</label>
									</div>
								</div>
							</div>
							<div v-else-if="current_question_type=='single'">
								<div class="flex items-center mb-[10px]">
									<img v-if="currentUserRecord.user_answer==currentTopicInfo.answer"
										src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
									<img v-else src="@/static/image/icon41.png" class="w-[24px] h-[24px] mr-[10px]"
										alt="" />
									<label v-if="currentUserRecord.user_answer==currentTopicInfo.answer"
										class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>
									<label v-else
										class="text-[20px] font-bold text-[#FF0100]">{{langInfo.study_paper_answer_wrong}}</label>
								</div>
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
									<label
										:class="currentUserRecord.user_answer==currentTopicInfo.answer?'text-[#68C340]':'text-[#FF0100]'">{{currentUserRecord.user_answer ||langInfo['no_answer']}}</label>
								</div>
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
									<label>{{currentTopicInfo.answer}}</label>
								</div>
							</div>

							<div class="text-justify text-[16px]  text-[#101010] flex ">
								<label class="font-semibold  min-w-[80px] flex justify-between">
									{{langInfo.study_paper_answer_tip}}：</label>
								<div v-html="currentTopicInfo.analysis"
									class="flex-1 text-[#101010] whitespace-pre-wrap">
								</div>
							</div>

						</div>
						<div @click="askVisible=true"
							class="flex items-center relative z-10 cursor-pointer text-[#D86D21] text-[16px]">
							<img src="@/static/image/icon42.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
							{{langInfo.study_paper_answer_submit}}
						</div>
						<!-- 水印 -->
						<div class=" absolute w-full h-full top-0 left-0 bg-repeat"
							:style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}">
						</div>
						<!-- 水印 -->
					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentNumber==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="currentNumber==Number(question_paper_question_count) ?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1 h-[78vh] flex flex-col">
					<div
						class="flex-1 mb-[10px]  flex flex-col shadow-01 rounded-[6px] pb-[20px] box-border  bg-white overflow-hidden">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class="">
							<div class="" v-for="(item,index) in topicList" :key="index">
								<div
									class="px-[20px] mb-[10px] box-border relative text-[16px] text-[#1B2128] font-bold">
									Part {{index+1}} {{item.name}}
								</div>

								<div v-if="item.question_type=='single'"
									class="flex flex-wrap overflow-y-auto    px-[13px] box-border ">
									<div @click="selectTopic(item,index,ite,inde)"
										:class="[ ite.userrecord && ite.userrecord.user_answer ==ite.question.answer?'bg-[#68C340] text-white':'bg-[#ff6969] text-white',, currentTopic==inde&&partIndex==index?'bg-[#A6A6A6] text-white':'']"
										class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
										v-for="(ite,inde) in item.data" :key="inde">
										<img v-if="ite.question.is_user_question==1&&ite.question.is_user_collection==1"
											src="@/static/image/icon55.png"
											class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
										<img v-else-if="ite.question.is_user_question==1"
											src="@/static/image/icon55.png"
											class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
											srcset="" />

										<img v-if="ite.question.is_user_collection==1" :src="collectActive"
											class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
											alt="" srcset="" />
										<label class="cursor-pointer"> {{inde + 1 }}</label>
									</div>
								</div>
								<div class="" v-else-if="item.question_type=='case'">

									<div class="" v-for="(ite,ind) in item.data" :key="ind">
										<div
											class="px-[20px] mb-[10px] box-border relative text-[16px] text-[#1B2128] font-bold">
											{{langInfo['case']}} {{ind+1}}
										</div>
										<div class="flex flex-wrap overflow-y-auto   px-[13px] box-border ">

											<div @click="selectCaseTopic(item,index,ite,ind,iteClass,indeClass)"
												:class="[ iteClass.userrecord && (iteClass.userrecord.user_answer ==iteClass.question.answer)?'bg-[#68C340] text-white':'bg-[#ff6969] text-white',partIndex==index &&caseIndex==ind&&currentTopic==indeClass?'bg-[#A6A6A6] text-white':'']"
												class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
												v-for="(iteClass,indeClass) in ite.data" :key="indeClass">
												<!-- 	<img v-if="iteClass.question.is_user_question==1&&iteClass.question.is_user_collection==1"
													src="@/static/image/icon55.png"
													class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt=""
													srcset="" />
												<img v-else-if="iteClass.question.is_user_question==1"
													src="@/static/image/icon55.png"
													class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
													srcset="" /> -->

												<img v-if="iteClass.question.is_user_collection==1" :src="collectActive"
													class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
													alt="" srcset="" />
												<label class="cursor-pointer"> {{indeClass + 1 }}</label>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
					<div
						class="shadow-01 mb-[10px] rounded-[6px]  pt-[26px] pb-[20px] box-border bg-white   flex flex-col items-center justify-center">
						<div class="mb-[10px] text-[#101010]">
							{{langInfo.study_paper_answer_score}}
						</div>
						<div class="text-[20px] text-[#FF0000] font-bold">
							{{question_exam.score}}
						</div>
					</div>
					<div @click="backStudyCenter()"
						class="shadow-01 rounded-[6px] cursor-pointer h-[56px]  bg-[#E6F2FF] text-[#3894FF] flex items-center justify-center">
						{{langInfo.study_paper_answer_back}}
					</div>
				</div>
			</div>
		</div>

		<!-- 提问/纠错  type=0是提问1是回复 -->
		<questionCorrection :askVisible="askVisible" :order_item_id="order_item_id"
			:id=" currentTopicInfo.question_type==6?caseTopicInfo.id:currentTopicInfo.id"
			:title="langInfo.study_question_answer" :course_subject_id="currentTopicInfo.course_subject_id"
			@close="closeVisible">
		</questionCorrection>
		<!-- 提问/纠错 -->
	</div>
</template>

<script>
	import examHeader from '@/components/examHeader.vue'

	import questionCorrection from '@/components/questionCorrection.vue'
	export default {
		components: {
			examHeader,

			questionCorrection
		},
		data() {
			return {


				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + '@' + this.$common
					.currentTime() + '@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,


				title: '',

				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),


				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),

				optionsList: [],
				currentTopicInfo: {
					id: '',
					content: '',
					question_type: '',
					shortContent: '',
					isJudgmentSelect: '',
				},
				currentTopic: 0,

				topicList: [],
				askVisible: false, //疑问纠错

				id: '',
				identification: '',

				currentUserRecord: {
					id: '',
					user_answer: ''
				},
				questionInfo: {
					title: '',
					score: 0
				},
				viewMethod: "",
				question_exam: {},
				langInfo: {},
				order_item_id: '',
				type: '', //1 自由  2后台



				question_paper_id: '',
				partList: [],
				partIndex: 0,
				part_info: { name: '' },
				caseTopicList: [],
				question_type: '', //6 案例分析题

				caseIndex: 0,

				caseTopicInfo: {
					id: '',
					content: '',
					question_type: '',
					shortContent: '',
					isJudgmentSelect: '',
					userrecord: null
				},
				caseOption: [],

				currentNumber: 0,
				question_paper_question_count: 0,
				sequence: 1, //1正序  2倒序 

				current_question_type: 'single', //single   case


			}
		},
		mounted() {
			if (this.$route.query.viewMethod) {
				this.viewMethod = this.$route.query.viewMethod
			}
			this.id = this.$route.query.id
			this.order_item_id = this.$route.query.order_item_id
			this.identification = this.$route.query.identification
			this.getQuestionInfo()

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getCurrentInfo() {

				this.current_question_type = this.topicList[this.partIndex].question_type

				this.currentUserRecord = {
					id: '',
					user_answer: ''
				}
				this.optionsList = [];
				this.caseOption = [];



				if (this.topicList[this.partIndex].question_type == "case") {
					this.currentTopicInfo = this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic]
						.question;

					let userrecord = this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord

					if (userrecord) {
						this.currentUserRecord = userrecord
					}

					if (this.currentTopicInfo.question_type == 1) {
						this.caseOption = this.currentTopicInfo.options
					}

				} else if (this.topicList[this.partIndex].question_type == "single") {


					this.optionsList = []
					this.caseOption = []
					let info = this.topicList[this.partIndex].data[this.currentTopic]
					this.currentTopicInfo = this.topicList[this.partIndex].data[this.currentTopic].question;

					this.optionsList = this.currentTopicInfo.options

					if (info.userrecord) {
						let userrecord = info.userrecord

						this.currentUserRecord = userrecord

						this.optionsList.forEach((item, index) => {
							this.$set(item, 'isSelect', false)
							if (userrecord.user_answer == item.key) {
								item.isSelect = true
							} else {
								item.isSelect = false
							}
						})
					} else {
						console.log("无");
						this.optionsList.forEach((item, index) => {
							this.$set(item, 'isSelect', false)
						})
					}

				}
				
				
				if(this.currentTopicInfo.content){
					this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)
				}
				
				
				this.getCurrentNumber()
				this.get_user_log()
			},
			
			decodeHtml(html) {
				if (!html) return ''
			
				const textarea = document.createElement('textarea')
				textarea.innerHTML = html
			
				return textarea.value
			},
			
			getCurrentNumber() {
				console.log("获取数量=====");

				let num = 0

				let tpIndex = 0
				let isExit = false
				for (let i = 0; i < this.topicList.length; i++) {
					console.log("i===" + i);
					let item = this.topicList[i];
					if (item.question_type == 'single') {
						for (let j = 0; j < item.data.length; j++) {
							let itm = item.data[j];
							if (this.partIndex == i && this.currentTopic == j) {
								isExit = true
								break;
							}
							tpIndex++
						}
					} else if (item.question_type == 'case') {

						for (let j = 0; j < item.data.length; j++) {
							let itm = item.data[j];

							if (isExit == true) {
								break
							}
							for (let d = 0; d < itm.data.length; d++) {
								if (this.partIndex == i && this.caseIndex == j && this.currentTopic == d) {
									isExit = true
									break;
								}
								tpIndex++
							}
						}
					}
				}

				this.currentNumber = tpIndex + 1
			},
			get_user_log() {
				this.$api.user_log({
					action: 'question',
					type: this.type,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			getQuestionInfo() {
				this.$api.getQuestionPart({
					id: this.id,
					identification: this.identification,
					analysis: 1,
					order_item_id: this.order_item_id,
					question_paper_id: this.question_paper_id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.title = res.data.title

					this.question_paper_question_count = res.data.question_paper_question_count

					document.title = this.title

					this.partList = res.data.part
					//question_type 题型：single=单选,multiple=多选,judge=判断,essay=简答,case=案例分析

					this.questionInfo = res.data
					this.type = res.data.type
					this.question_exam = res.data.question_exam


					// is_user_collection=是否收藏0否1是


					res.data.part.forEach((item, index) => {
						if (item.question_type == 'single') {
							item.data.forEach((itm, indx) => {
								itm.question.options.forEach((it, ind) => {
									this.$set(it, 'isSelect', false)
								})

							})
						} else if (item.question_type == 'case') {

							item.data.forEach((itm, indx) => {
								itm.data.forEach((it, ind) => {

									if (it.question.question_type == 1) {
										it.question.options.forEach((it1,
											ind1) => {
											this.$set(it1, 'isSelect',
												false)
										})
									} else if (it.question.question_type == 5) {
										this.$set(it.question, 'shortContent', '')
									} else if (it.question.question_type == 3) {
										this.$set(it.question, 'isJudgmentSelect',
											-1)
									}
								})
							})

						}
					})


					let tpIndex = 0
					let isExit = false
					for (let i = 0; i < res.data.part.length; i++) {
						let item = res.data.part[i];
						if (item.question_type == 'single') {
							for (let j = 0; j < item.data.length; j++) {
								let itm = item.data[j];
								if (tpIndex == res.data.key_) {
									this.partIndex = i
									this.currentTopic = j;

									isExit = true
									break;
								}
								tpIndex++
							}


						} else if (item.question_type == 'case') {

							for (let j = 0; j < item.data.length; j++) {
								let itm = item.data[j];

								if (isExit == true) {
									break
								}
								for (let d = 0; d < itm.data.length; d++) {
									if (tpIndex == res.data.key_) {
										this.partIndex = i
										this.caseIndex = j
										this.currentTopic = d;
										isExit = true
										break;
									}
									tpIndex++
								}

							}

						}

					}




					this.topicList = res.data.part
					console.log("this.topicList===");
					console.log(this.topicList);



					this.getCurrentInfo()


				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 上一页
			preTopic() {


				if (this.currentNumber == 1) {
					return
				}


				if (this.topicList[this.partIndex].question_type == "case") {

					if (this.currentTopic == 0 && this.caseIndex == 0 && this.partIndex > 0) {
						this.sequence = 2;
						this.partIndex--
						this.getPreInfo()
						return
					} else if (this.currentTopic == 0 && this.caseIndex > 0 && this.partIndex > 0) {
						this.sequence = 2
						this.caseIndex--
						this.getPreInfo()
						return
					}
					this.currentTopic--
					this.sequence = 2
					this.getCurrentInfo()


				} else if (this.topicList[this.partIndex].question_type == "single") {

					if (this.currentTopic == 0 && this.partIndex > 0) {
						this.partIndex--
						this.sequence = 2
						this.getPreInfo()
						return
					}

					this.currentTopic--
					this.sequence = 2
					this.getCurrentInfo()
				}

			},
			getPreInfo() {
				console.log("this.topicList[this.partIndex].question_type===");
				console.log(this.topicList[this.partIndex].question_type);

				if (this.topicList[this.partIndex].question_type == "case") {

					this.currentTopic = this.topicList[this.partIndex].data[this.caseIndex].data.length - 1
					this.getCurrentInfo()

				} else if (this.topicList[this.partIndex].question_type == "single") {
					console.log("this.topicList[this.partIndex]==");
					console.log(this.topicList[this.partIndex].data);
					this.currentTopic = this.topicList[this.partIndex].data.length - 1

					this.getCurrentInfo()

				}

			},
			nextTopic() {

				if (this.currentNumber == this.question_paper_question_count) {
					return
				}

				if (this.topicList[this.partIndex].question_type == "case") {

					if (this.currentTopic == this.topicList[this.partIndex].data[this.caseIndex].data.length - 1) {
						if (this.caseIndex == this.topicList[this.partIndex].data.length - 1) {
							if (this.partIndex == this.topicList.length - 1) {
								return
							}

							this.currentTopic = 0
							this.caseIndex++
							this.sequence = 1
							this.getCurrentInfo()
							return

						}

						this.currentTopic = 0
						this.caseIndex++
						this.sequence = 1
						this.getCurrentInfo()

						return
					}

					this.currentTopic++
					this.sequence = 1
					this.getCurrentInfo()

				} else if (this.topicList[this.partIndex].question_type == "single") {


					if (Number(this.currentTopic) + 1 == this.topicList[this.partIndex].data.length) {
						if (this.partIndex == this.topicList.length - 1) {
							return
						}
						this.currentTopic = 0
						this.caseIndex = 0
						this.partIndex++
						this.sequence = 1
						this.getCurrentInfo()
						return
					}


					this.currentTopic++
					this.sequence = 1
					this.getCurrentInfo()

				}
			},


			// 上一部分
			prePartBtn() {
				this.caseIndex = 0
				this.sequence = 1
				this.prePartInfo()
			},

			// 上一部分
			prePartInfo() {
				if (this.partIndex == 0) {
					return
				}
				this.partIndex--
				this.question_paper_id = this.partList[this.partIndex].id;
				this.getQuestionInfo()

			},
			nextPart() {
				if (this.partIndex + 1 == this.partList.length) {
					return
				}


				this.caseIndex = 0
				this.sequence = 1;
				this.partIndex++
				this.question_paper_id = this.partList[this.partIndex].id;
				this.getQuestionInfo()
			},

			selectTopic(item, index, ite, inde) {

				this.currentTopic = inde
				this.partIndex = index
				this.getCurrentInfo()
			},

			selectCaseTopic(item, index, ite, ind, iteClass, indeClass) {
				this.partIndex = index;
				this.caseIndex = ind;
				this.currentTopic = indeClass


				this.getCurrentInfo()
			},

			// 返回学习中心
			backStudyCenter() {
				window.close()

				// if (this.viewMethod == 'read') {
				// 	this.$router.go(-1)
				// } else {
				// 	this.$router.go(-4);
				// }
			},
			// 收藏
			collectClick() {
				console.log(12121);
				let course_question_id = this.currentTopicInfo.id


				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}

				if (this.topicList[this.partIndex].question_type == "case") {
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].question
						.is_user_collection = this.currentTopicInfo.is_user_collection
				} else if (this.topicList[this.partIndex].question_type == "single") {

					this.topicList[this.partIndex].data[this.currentTopic].question.is_user_collection = this
						.currentTopicInfo.is_user_collection

				}


				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: course_question_id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			closeVisible() {
				this.askVisible = false
			}

		}
	}
</script>

<style scoped>
	
	/deep/p img {
		width: 100% !important;
	}
	
	/* ::-webkit-scrollbar {
		display: none;
	} */

	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;

	}

	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}
</style>